var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 12,
    height: 16,
    rx: 2,
    fill: "#FDD835"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8 6.89543 8.89543 6 10 6H17C18.1046 6 19 6.89543 19 8V18C19 19.1046 18.1046 20 17 20H8V8Z",
    fill: "#FFF9C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19V18L9 20H7C7.55228 20 8 19.5523 8 19Z",
    fill: "#FFF9C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.83616V8.30037C9 8.13448 9.13377 8 9.2988 8H12.9422C13.0119 8 13.022 8.10119 12.9536 8.11509L12.0428 8.30022C10.9614 8.52 9.99121 9.10132 9.28593 9.94213C9.18863 10.0581 9 9.98791 9 9.83616Z",
    fill: "#FDD835"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.501b2dd4225ad76599ea7a6d2ac67015.svg";
export { ForwardRef as ReactComponent };